import axiosConfig from '../../config/axiosConfig';
import {
  SEND_VERIFICATION_CODE,
  VERIFICATION_CODE_SUCCESS,
  VERIFICATION_CODE_ERROR,
  LIST_SESSIONS,
  LIST_SESSIONS_SUCCESS,
  LIST_SESSIONS_ERROR,
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
} from '../dispatchTypes';

export const sendVerificationCode = (dispatch, bodyData) => {
  dispatch({
    type: SEND_VERIFICATION_CODE,
  });

  return axiosConfig
    .post('/phone_verification', bodyData)
    .then(() => {
      dispatch({
        type: VERIFICATION_CODE_SUCCESS,
      });
    })
    .catch(error => {
      dispatch({
        type: VERIFICATION_CODE_ERROR,
        errorMessage: error.response.data.error_message,
      });
      throw error;
    })
    .catch(() => {
      dispatch({
        type: VERIFICATION_CODE_ERROR,
        errorMessage:
          'Something went wrong, please refresh your browser and try again',
      });
    });
};

export const sendSMSCode = async bodyData => {
  const response = await axiosConfig.post('/phone_verification', bodyData);
  return response.data;
};

export const registerUser = async payload => {
  const response = await axiosConfig.post('/users', payload);
  return response;
};

export const listUserSessions = (dispatch, userId, userSessions) => {
  dispatch({
    type: LIST_SESSIONS,
  });

  const page = userSessions ? userSessions.pagination.page + 1 : 1;
  const search =
    process.env.NEXT_PUBLIC_SOURCE_PACKAGE === 'merchant' ? 'merchant' : 'user';

  axiosConfig
    .get(`/users/${userId}/sessions`, {
      params: {
        page,
        per: 100,
        search,
      },
    })
    .then(response => {
      let userSessionsData = response.data;
      if (userSessions) {
        userSessionsData.sessions = [
          ...userSessions.sessions,
          ...userSessionsData.sessions,
        ];
      }
      dispatch({
        type: LIST_SESSIONS_SUCCESS,
        userSessions: userSessionsData,
      });
    })
    .catch(error => {
      dispatch({
        type: LIST_SESSIONS_ERROR,
        errorMessage: error.response.data.error_message,
      });
    })
    .catch(() => {
      dispatch({
        type: LIST_SESSIONS_ERROR,
        errorMessage: 'Something went wrong.',
      });
    });
};

export const logoutUser = (dispatch, session, userSessions) => {
  dispatch({
    type: LOGOUT,
  });
  axiosConfig
    .delete(`/sessions/${session.id}`)
    .then(() => {
      if (userSessions) {
        const updatedSessions = userSessions.sessions;
        updatedSessions.splice(userSessions.sessions.indexOf(session), 1);
        userSessions.sessions = updatedSessions;
        userSessions.pagination.count = userSessions.pagination.count - 1;

        dispatch({
          type: LIST_SESSIONS_SUCCESS,
          userSessions,
        });
      }

      dispatch({
        type: LOGOUT_SUCCESS,
        isRedirect: !userSessions,
      });
    })
    .catch(error => {
      console.error(error.response);
      dispatch({
        type: LOGOUT_ERROR,
        errorMessage: error.response.data.error_message,
        isRedirect: !userSessions,
      });
    });
};
